import {apiClient} from 'app/components/shared';
import {PaymentContract} from '../model';

export class PaymentApi {
  static async getPayment(teamId: string) {
    return apiClient.get<PaymentContract.Metadata>(
      `/front/api/v1t/team/${teamId}/teams/${teamId}/billing/payment_info`,
    );
  }
}
